import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { faChevronRight, } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-tech-communities-modal',
  templateUrl: './tech-communities-modal.component.html',
  standalone: false,
  styleUrl: './tech-communities-modal.component.scss'
})
export class TechCommunitiesModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private router: Router) { }
  
  ngOnInit() { }

  icons = {
    faChevronRight,
  }

  request(){
    window.open('https://aka.ms/MCTLounge/RequestAccess','_blank');
  }

  signin(){
    if (this.router.url === '/extreme-labs') {
    window.open('https://instructoraccess.learnondemand.net','_blank');
    }
    else{
      window.open('https://aka.ms/mctlounge','_blank');
    }
  }

}
